import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table } from '@devexpress/dx-react-grid-bootstrap3';
import { push as pushAction } from 'react-router-redux';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

class RowComponent extends Component {
	shouldComponentUpdate = ({ style, tableRow }) => {
		const lastProps = this.props;

		return (
			!isEqual(style, lastProps.style)
			|| !isEqual(tableRow, lastProps.tableRow)
		);
	};

	onClickRow = (event) => {
		const { row, push } = this.props;

		const preventNavigation = get(event, ['target', 'dataset', 'preventNavigation'], false);

		if (preventNavigation) return;

		push(`/jobs/${row.Id}`);
	};

	render() {
		const {
			children,
			style,
			tableRow,
		} = this.props;

		return (
			<Table.Row
				style={style}
				tableRow={tableRow}
				onClick={this.onClickRow}
				className="cursor-pointer"
			>
				{ children }
			</Table.Row>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	push : bindActionCreators(pushAction, dispatch),
});

RowComponent.propTypes = {
	children : PropTypes.any,
	push     : PropTypes.func.isRequired,
	row      : PropTypes.object.isRequired,
	style    : PropTypes.object,
	tableRow : PropTypes.object.isRequired,
};

RowComponent.defaultProps = {
	children : undefined,
	style    : {},
};

export default connect(null, mapDispatchToProps)(RowComponent);
